module.exports = __webpack_public_path__ + "static/media/wind.468bd72a.png";